import { Injectable, OnDestroy} from '@angular/core';
import { BaseDestroyable } from '@core/base-destroyable';
import { Subscription, BehaviorSubject } from 'rxjs';
import {  map, tap, distinctUntilChanged, takeUntil, filter } from 'rxjs/operators';
import { GlobalSettingsService } from '@core/globalSettings.service';
import { BusinessPartnerTypeNames, FeatureToggle, RoleTypeEnum, SoftwareOptionsForCompany } from '@shared/enums';
import { Company } from '@shared/generalInterfaces';
import { FeaturesToggleSettingsService } from 'app/featuresToggleSettings/service/featuresToggleSettings.service';
import { Utils } from '@shared/utils.service';
import { SoftwareOptionsService } from 'app/core/companySoftwareOptions/service/softwareOptions.service';


@Injectable({
	providedIn: 'root',
})
export class UserSettingsService extends BaseDestroyable  implements OnDestroy  {
	isNotificationsEnabled = new BehaviorSubject<boolean>(false);
	isNotificationsSwoEnabled: boolean;
	isMatNotificationsFfExists: boolean;
	isMidcNotificationsFfExists: boolean;
	ftSubscription: Subscription;

	constructor(
		private globalSettingsService: GlobalSettingsService,
		private featuresToggleSettingsService: FeaturesToggleSettingsService,
		private readonly utils: Utils,
		private readonly softwareOptionsService: SoftwareOptionsService
	) {
		super();
		this.updateSoftwareOptions(this.globalSettingsService.get()?.companySoftwareOptions);
		this.trackSoftwareOptionsChanges();
		this.updateFeaturesToggle();
	}
	updateNotificationsSettingsVisibility() {
		var isDoctor = this.globalSettingsService.get()?.roleType === RoleTypeEnum.Doctor;
		const notificationsEnabled = isDoctor && this.isDentalClinic() && this.isMidcNotificationsFfExists && 
		(this.isMatNotificationsFfExists || this.isNotificationsSwoEnabled);
		this.isNotificationsEnabled.next(notificationsEnabled);
	}
	public isDentalClinic(): Boolean {
		const companyInfo = this.getCompanyById(this.globalSettingsService.get()?.selectedCompanyId);
		if(companyInfo?.isDentalClinic) {
			return true;
		}
		const businessPartnerTypeNames =  companyInfo?.businessPartnerTypeNames?.split(',').map(value => value.trim());
		return businessPartnerTypeNames?.includes(BusinessPartnerTypeNames.DentalOffice);
	}
	private getCompanyById(id: number): Company {
		return this.globalSettingsService.get().companies.filter((c: Company) => c.id === id)[0];
	}
	updateSoftwareOptions(softwareOptions: number[]): void {
		if(!softwareOptions) { 
			this.isNotificationsSwoEnabled = false;
		} else {
			this.isNotificationsSwoEnabled = softwareOptions
				.some(so => so === SoftwareOptionsForCompany.EmailNotifications);
		}
		this.updateNotificationsSettingsVisibility();
	}
	updateFeaturesToggle(): void {
		this.ftSubscription = this.featuresToggleSettingsService.getFeaturesToggleSettings()
			.pipe(
				tap(() => {
				this.isMatNotificationsFfExists = this.featuresToggleSettingsService.isVisibleFeature(FeatureToggle.EmailNotifications, false);
				this.isMidcNotificationsFfExists = this.featuresToggleSettingsService.isVisibleFeature(FeatureToggle.DisplayNotificationsTab, false);
				this.updateNotificationsSettingsVisibility();
			})).subscribe();
	}
	trackSoftwareOptionsChanges(): void{
		this.globalSettingsService.contextChanged
			.pipe(
				takeUntil(this.componentAlive$),
				map(c => c.softwareOptions),
				filter(so => !!so),
				distinctUntilChanged(),
				tap(so => this.updateSoftwareOptions(so))
			).subscribe();
	}
	public isReferralOffice() : boolean {
		const globalSettings = this.globalSettingsService.get();
    	const companyInfo = this.getCompanyById(globalSettings?.selectedCompanyId);

    	const businessPartnerTypeNames = companyInfo?.businessPartnerTypeNames?.split(',').map(value => value.trim());
    	const isReferralOffice = businessPartnerTypeNames?.includes(BusinessPartnerTypeNames.ReferralOffice);

    	const isSwoExist = this.softwareOptionsService.isSoftwareOptionExists(
        	SoftwareOptionsForCompany.cswo_SendToClientDisplay,
        	globalSettings?.companySoftwareOptions
    	);

    	return isReferralOffice && isSwoExist;
	}
	ngOnDestroy(): void {
		this.utils.clearObservablesSubscriptions(this);
	}
}
